import { render, staticRenderFns } from "./MessagingHome.vue?vue&type=template&id=157562c6&scoped=true"
import script from "./MessagingHome.vue?vue&type=script&lang=js"
export * from "./MessagingHome.vue?vue&type=script&lang=js"
import style0 from "./MessagingHome.vue?vue&type=style&index=0&id=157562c6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157562c6",
  null
  
)

export default component.exports